<fieldset
  class="field-group"
  [ngClass]="{
    disabled: disabled,
    hilite: checkDiff(field.AffectedSystems),
    invalid: hasErrors,
  }"
>
  <legend>Systems Affected</legend>
  <div class="row">
    <div class="d-flex col-xs-12 col flex-column">
      <!-- Beamline -->
      <div class="d-flex flex-column">
        <mat-checkbox
          color="primary"
          [ngClass]="{
            hilite: checkDiff(field.Beamline),
            invalid: ctrlBeamline.invalid,
          }"
          [formControl]="ctrlBeamline"
          (change)="onSystemChanged()"
          >{{ beamlineLabel }}</mat-checkbox
        >
        <resource-chips
          [selectedResources]="beamlineLocations"
          [resourceTypes]="beamlineResourceTypeIDs"
          [checkEmpty]="rsf?.beamLine"
          [placeholder]="beamlineLabel ?? 'Beamline Locations'"
          [disabled]="!(!disabled && ctrlBeamline.value)"
          (onEdit)="onBeamlineLocationsChanged($event)"
          [hilite]="checkDiff(field.BeamlineLocations)"
          [noSubscript]="true"
        >
        </resource-chips>
      </div>
      <!-- Accelerator -->
      <div class="d-flex flex-column">
        <mat-checkbox
          color="primary"
          [ngClass]="{
            hilite: checkDiff(field.Accelerator),
            invalid: ctrlAccelerator.invalid,
          }"
          [formControl]="ctrlAccelerator"
          (change)="onSystemChanged()"
          >{{ acceleratorLabel }}</mat-checkbox
        >
        <resource-chips
          [selectedResources]="acceleratorLocations"
          [resourceTypes]="acceleratorResourceTypeIDs"
          [checkEmpty]="rsf?.accelerator"
          [placeholder]="acceleratorLabel ?? 'Accelerator Locations'"
          [disabled]="!(!disabled && ctrlAccelerator.value)"
          (onEdit)="onAcceleratorLocationsChanged($event)"
          [hilite]="checkDiff(field.AcceleratorLocations)"
          [noSubscript]="true"
        ></resource-chips>
      </div>

      <!-- Other Systems -->
      <div class="d-flex flex-column">
        <mat-checkbox
          color="primary"
          [ngClass]="{
            hilite: checkDiff(field.OtherSystems),
            invalid: ctrlOtherSystem.invalid,
          }"
          [formControl]="ctrlOtherSystem"
          (change)="onSystemChanged()"
          >{{ otherSystemsLabel }}</mat-checkbox
        >
        <mat-form-field>
          <mat-label>Other Systems</mat-label>
          <mat-chip-grid
            #chipGrid
            aria-label="Enter Other Systems"
            [formControl]="ctrlOtherSystems"
          >
            <mat-chip-row
              *ngFor="let os of rsfProxy?.rsfOtherSystems"
              (removed)="removeOtherSystem(os)"
            >
              {{ os.description }}
              <button matChipRemove aria-label="'remove ' + keyword">
                <mat-icon>cancel</mat-icon>
              </button>
            </mat-chip-row>
          </mat-chip-grid>
          <input
            #otherSystemInput
            placeholder="New Other System..."
            [matChipInputFor]="chipGrid"
            (matChipInputTokenEnd)="addOtherSystem($event)"
            (blur)="addOtherSystemFromBlur(otherSystemInput)"
          />
          <mat-error *ngIf="ctrlOtherSystems.invalid">{{
            getErrorMsg(ctrlOtherSystems)
          }}</mat-error>
        </mat-form-field>
      </div>
    </div>
    <div class="col-xs-12 col">
      <!-- Type of Work -->
      <fieldset
        class="field-group mb-2"
        [ngClass]="{
          disabled: disabled,
          hilite: checkDiff(field.AffectedSystems),
          invalid:
            ctrlShielding.invalid ||
            ctrlPPS.invalid ||
            ctrlRadMonitors.invalid ||
            ctrlPPSModification.invalid ||
            ctrlShlModification.invalid ||
            ctrlPPSOther.invalid,
        }"
      >
        <legend>Type of Work</legend>
        <!-- Bug 6961: wrap the Type of Work checkbox groups when the column is too narrow for them side by side -->
        <div
          class="d-flex flex-wrap"
          [ngClass]="{
            'justify-content-start gap-6': !ctrlPPS.value,
            'justify-content-between gap-3': ctrlPPS.value,
          }"
        >
          <div class="d-flex flex-column">
            <!-- Shielding -->
            <mat-checkbox
              color="primary"
              class="tree-root"
              [ngClass]="{
                hilite: checkDiff(field.Shielding),
                invalid: ctrlShielding.invalid,
              }"
              [formControl]="ctrlShielding"
              (change)="onSystemChanged()"
              >Shielding</mat-checkbox
            >

            <div
              [ngClass]="{ invisible: !ctrlShielding.value }"
              class="tree-container"
            >
              <div class="tree-branch">
                <div class="tree-branch-content">
                  <mat-checkbox
                    color="primary"
                    class="sub-checkbox small"
                    [ngClass]="{
                      hilite: checkDiff(field.ShieldingRemoveReplace),
                    }"
                    [formControl]="ctrlShlRemoveReplace"
                    (change)="onSystemChanged()"
                    >Remove/Replace</mat-checkbox
                  >
                </div>
              </div>

              <div class="tree-branch">
                <div class="tree-branch-content flex-column">
                  <mat-checkbox
                    color="primary"
                    class="sub-checkbox small tree-root"
                    [ngClass]="{
                      hilite: checkDiff(field.ShieldingModification),
                      invalid: ctrlShlModification.invalid,
                    }"
                    [formControl]="ctrlShlModification"
                    (change)="onSystemChanged()"
                    >Modification</mat-checkbox
                  >
                  <div
                    [ngClass]="{ invisible: !ctrlShlModification.value }"
                    class="tree-container tree-container-row flex-row"
                  >
                    <div class="tree-branch">
                      <div class="tree-branch-content">
                        <mat-checkbox
                          color="primary"
                          class="sub-checkbox small"
                          [ngClass]="{
                            hilite: checkDiff(field.ShieldingModificationARC),
                            invisible: !ctrlShlModification.value,
                          }"
                          [formControl]="ctrlShlModificationARC"
                          (change)="onSystemChanged()"
                          >ARC</mat-checkbox
                        >

                        <mat-checkbox
                          color="primary"
                          class="sub-checkbox small ml-5"
                          [ngClass]="{
                            hilite: checkDiff(field.ShieldingModificationBRC),
                            invisible: !ctrlShlModification.value,
                          }"
                          [formControl]="ctrlShlModificationBRC"
                          (change)="onSystemChanged()"
                          >BRC</mat-checkbox
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="d-flex flex-column">
            <!-- PPS -->
            <mat-checkbox
              class="tree-root"
              color="primary"
              [ngClass]="{
                hilite: checkDiff(field.PPS),
                invalid: ctrlPPS.invalid,
              }"
              [formControl]="ctrlPPS"
              (change)="onSystemChanged()"
              >PPS</mat-checkbox
            >
            <div
              [ngClass]="{ invisible: !ctrlPPS.value }"
              class="tree-container"
            >
              <div class="tree-branch">
                <div class="tree-branch-content flex-column"></div>
              </div>
              <div class="tree-branch">
                <div class="tree-branch-content">
                  <mat-checkbox
                    class="sub-checkbox small"
                    color="primary"
                    [ngClass]="{
                      hilite: checkDiff(field.PPSMaintenance),
                    }"
                    [formControl]="ctrlPPSMaintenance"
                    (change)="onSystemChanged()"
                    >Maintenance</mat-checkbox
                  >
                </div>
              </div>
              <div class="tree-branch">
                <div class="tree-branch-content flex-column">
                  <mat-checkbox
                    class="sub-checkbox small tree-root"
                    color="primary"
                    [ngClass]="{
                      hilite: checkDiff(field.PPSModification),
                      invalid: ctrlPPSModification.invalid,
                    }"
                    [formControl]="ctrlPPSModification"
                    (change)="onSystemChanged()"
                    >PPS Modification</mat-checkbox
                  >
                  <div
                    [ngClass]="{ invisible: !ctrlPPSModification.value }"
                    class="tree-container tree-container-row"
                  >
                    <div class="tree-branch">
                      <div class="tree-branch-content">
                        <mat-checkbox
                          color="primary"
                          class="sub-checkbox small"
                          [ngClass]="{
                            hilite: checkDiff(field.PPSModificationARC),
                          }"
                          [formControl]="ctrlPPSModificationARC"
                          (change)="onSystemChanged()"
                          >ARC</mat-checkbox
                        >
                        <mat-checkbox
                          color="primary"
                          class="sub-checkbox small ml-5"
                          [ngClass]="{
                            hilite: checkDiff(field.PPSModificationBRC),
                          }"
                          [formControl]="ctrlPPSModificationBRC"
                          (change)="onSystemChanged()"
                          >BRC</mat-checkbox
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            class="d-flex flex-column mr-2 mt-2"
            [ngClass]="{ invisible: !ctrlPPS.value }"
          >
            <label
              color="primary"
              class="sub-checkbox tree-root pb-2"
              [ngClass]="{ disabled: disabled }"
              >PPS Subsystem</label
            >
            <div class="tree-container">
              <div class="tree-branch">
                <div class="tree-branch-content flex-row">
                  <mat-checkbox
                    color="primary"
                    class="sub-checkbox small"
                    [ngClass]="{
                      hilite: checkDiff(field.PPSAcis),
                    }"
                    [formControl]="ctrlPPSAcis"
                    (change)="onSystemChanged()"
                    >ACIS</mat-checkbox
                  >
                </div>
              </div>
              <div class="tree-branch">
                <div class="tree-branch-content">
                  <mat-checkbox
                    color="primary"
                    class="sub-checkbox small"
                    [ngClass]="{
                      hilite: checkDiff(field.RadMonitors),
                      invalid: ctrlRadMonitors.invalid,
                    }"
                    [formControl]="ctrlRadMonitors"
                    (change)="onSystemChanged()"
                    >Rad Monitors</mat-checkbox
                  >
                </div>
              </div>
              <div class="tree-branch">
                <div class="tree-branch-content">
                  <mat-checkbox
                    color="primary"
                    class="sub-checkbox small"
                    [ngClass]="{
                      hilite: checkDiff(field.TOMBIS),
                      invalid: ctrlTombis.invalid,
                    }"
                    [formControl]="ctrlTombis"
                    (change)="onSystemChanged()"
                    >TOMBIS</mat-checkbox
                  >
                </div>
              </div>
              <div class="tree-branch">
                <div class="tree-branch-content">
                  <mat-checkbox
                    color="primary"
                    class="sub-checkbox small"
                    [ngClass]="{
                      hilite: checkDiff(field.PPSOther),
                      invalid: ctrlPPSOther.invalid,
                    }"
                    [formControl]="ctrlPPSOther"
                    (change)="onSystemChanged()"
                    >Other</mat-checkbox
                  >

                  <mat-form-field
                    [ngClass]="{ invisible: !ctrlPPSOther.value }"
                    class="no-subscript ml-3"
                  >
                    <mat-label>Other PPS Subsystem</mat-label>
                    <input
                      matInput
                      [formControl]="ctrlPPSOtherText"
                      [ngClass]="{
                        hilite: checkDiff(field.PPSOtherText),
                      }"
                      (input)="onSystemChanged()"
                    />
                  </mat-form-field>
                </div>
              </div>
            </div>
          </div>
          <div
            class="d-flex flex-column mr-2 mt-2"
            [ngClass]="{ invisible: !ctrlRadMonitors.value }"
          >
            <label
              class="sub-checkbox tree-root pb-2"
              [ngClass]="{
                disabled: disabled,
                invalid: ctrlRadMonitors.invalid,
              }"
            >
              RAD Monitors
            </label>

            <div
              [ngClass]="{ invisible: !ctrlRadMonitors.value }"
              class="tree-container"
            >
              <div class="tree-branch">
                <mat-checkbox
                  color="primary"
                  class="sub-checkbox small w-100"
                  [ngClass]="{ hilite: checkDiff(field.RadMonitorsMoving) }"
                  [formControl]="ctrlRadMonitorsMoving"
                  (change)="onRadMonitorsChanged()"
                >
                  Moving without Disconnecting
                </mat-checkbox>
              </div>

              <div class="tree-branch">
                <mat-checkbox
                  color="primary"
                  class="sub-checkbox small w-100"
                  [ngClass]="{
                    hilite: checkDiff(field.RadMonitorsDisconnecting),
                  }"
                  [formControl]="ctrlRadMonitorsDisconnecting"
                  (change)="onRadMonitorsChanged()"
                >
                  Disconnecting Rad Monitors
                </mat-checkbox>
              </div>

              <div class="tree-branch">
                <mat-checkbox
                  color="primary"
                  class="sub-checkbox small w-100"
                  [ngClass]="{
                    hilite: checkDiff(field.RadMonitorsModifying),
                  }"
                  [formControl]="ctrlRadMonitorsModifying"
                  (change)="onRadMonitorsChanged()"
                >
                  Modify Location of Rad Monitor
                </mat-checkbox>
              </div>

              <div class="tree-branch">
                <mat-checkbox
                  color="primary"
                  class="sub-checkbox small w-100"
                  [ngClass]="{
                    hilite: checkDiff(field.RadMonitorsTripPoint),
                  }"
                  [formControl]="ctrlRadMonitorsTripPoint"
                  (change)="onRadMonitorsChanged()"
                >
                  Modify Trip Point
                </mat-checkbox>
              </div>
            </div>
          </div>
        </div>
      </fieldset>
      <error-subscript
        *ngIf="ctrlShielding.invalid"
        error="You must select at least one checkbox for Shielding"
      ></error-subscript>
      <error-subscript
        *ngIf="ctrlPPS.invalid"
        error="You must select at least one checkbox for PPS"
      ></error-subscript>
      <error-subscript
        *ngIf="ctrlPPSModification.invalid || ctrlShlModification.invalid"
        error="You must select at least one checkbox ARC or BRC"
      ></error-subscript>
      <error-subscript
        *ngIf="ctrlPPSOther.invalid"
        error="You must enter a value for Other PPS Subsystem"
      ></error-subscript>
      <error-subscript
        *ngIf="ctrlRadMonitors.invalid"
        error="You must select at least one checkbox for RAD Monitors"
      ></error-subscript>
    </div>
  </div>
</fieldset>
<error-subscript
  *ngIf="hasErrors"
  error="You must select at least one checkbox"
></error-subscript>

<div
  class="d-flex no-gutters gap-1 py-3"
  [ngClass]="{ invisible: !ctrlTombis.value && !rsfProxy?.tombis }"
>
  <div class="col">
    <rsf-main-s1-checkcard
      [hilite]="checkDiff(field.PPSPLCSet)"
      [control]="ctrlPPSPLCSet"
      [title]="'PPS PLC Set Pt / Parameter Access'"
      (changed)="onSystemChanged()"
    ></rsf-main-s1-checkcard>
  </div>
  <div class="col">
    <rsf-main-s1-checkcard
      [hilite]="checkDiff(field.PPSSoftware)"
      [control]="ctrlPPSSoftware"
      [title]="'PPS Software / Firmware Download'"
      (changed)="onSystemChanged()"
    ></rsf-main-s1-checkcard>
  </div>
  <div class="col">
    <rsf-main-s1-checkcard
      [hilite]="checkDiff(field.ETIAccess)"
      [control]="ctrlETIAccess"
      [title]="
        'ETI Access / TOMBIS Modification / TOMBIS Removal of Components'
      "
      (changed)="onSystemChanged()"
    ></rsf-main-s1-checkcard>
  </div>
  <div class="col">
    <rsf-main-s1-checkcard
      [hilite]="checkDiff(field.TOMBISPLCSet)"
      [control]="ctrlTOMBISPLCSet"
      [title]="'TOMBIS PLC Set Pt / Parameter Access'"
      (changed)="onSystemChanged()"
    ></rsf-main-s1-checkcard>
  </div>
  <div class="col">
    <rsf-main-s1-checkcard
      [hilite]="checkDiff(field.TOMBISSoftware)"
      [control]="ctrlTOMBISSoftware"
      [title]="'TOMBIS Software / Firmware Download'"
      (changed)="onSystemChanged()"
    ></rsf-main-s1-checkcard>
  </div>
  <div class="col">
    <rsf-main-s1-checkcard
      [hilite]="checkDiff(field.TopOffInterlockSetPoint)"
      [control]="ctrlTopOffInterlock"
      [title]="
        'TOP OFF Interlock set Point and/or Interlock threshold modification (requires AP approval)'
      "
      (changed)="onSystemChanged()"
    ></rsf-main-s1-checkcard>
  </div>
</div>
